import $ from 'jquery'
import ParamFicheMedicale from '@/views/parametres/configs/param-fiche-medical'
import ParamSagefemme from '@/views/parametres/configs/param-sagefemme'
import ParamAntecedents from '@/views/parametres/configs/param-antecedents'
import ConstantesCatalogue from '@/views/parametres/constantes-catalogue'
import ParamAccordionSection from '@/components/param-accordion-section'
import ProtocolesTypes from '@/views/parametres/protocoles-types'
import CertificatsModeles from '@/views/parametres/certificats-modeles/index.vue'

export default {
    name: 'dossier-soins',
    components: {
        ParamFicheMedicale, ParamSagefemme, ParamAntecedents, ConstantesCatalogue, ParamAccordionSection, ProtocolesTypes, CertificatsModeles
    },
    props: [],
    data() {
        return {}
    },
    computed: {
        activeRole() {
            return this.$store.getters['activeRole'];
        },
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },
    mounted() {
        setTimeout(() => {
            $('.show-on-fixed').fadeIn();
        }, 500);
    },
    methods: {}
}
